import { BannerTitle } from '@/components/BannerTitle/BannerTitle';
import { styled } from '@mui/material';

export const Banner = styled(BannerTitle)`
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`;
